/* eslint-disable quotes */
import React from "react";
import { Link } from "react-router-dom";

import ContactIcons from "../Contact/ContactIcons";

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
      </Link>
      <header>
        <h2>Azhar</h2>
        <p>
          <a href="mailto:azhar89143@gmail.com">azhar89143@gmail.com</a>
        </p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>
        Hi, I&#39;m Azhar. I am a passionate frontend software engineer
        specializing in React and Next.js. Currently, I work at Mint Solutions
        in Dubai, where I focus on crafting scalable, user-centric web
        applications. Previously, I honed my skills as a Junior Software
        Developer at Deepnetsoft Solutions Pvt Ltd, optimizing app performance
        and seamless deployments.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes("/resume") ? (
            <Link to="/resume" className="button">
              Learn More
            </Link>
          ) : (
            <Link to="/about" className="button">
              About Me
            </Link>
          )}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">
        &copy; Azhar A <Link to="/">azhar89143@gmail.com</Link>.
      </p>
    </section>
  </section>
);

export default SideBar;
